import styled from 'react-emotion'
import themeVars from 'ui_theme/site/globals/site.variables'

export default styled('span')`
  font-size: ${themeVars.small};
  letter-spacing: 0.15384615rem;
`
